const exportFile = (buffer: Uint8Array, fileName: string, fileType: string) => {
  // สร้าง Blob จาก Buffer
  const blob = new Blob([buffer], {type: fileType})

  // สร้าง URL สำหรับ Blob
  const url = URL.createObjectURL(blob)

  // สร้างลิงก์ดาวน์โหลด
  const link = document.createElement('a')
  link.href = url
  link.download = fileName

  // คลิกลิงก์เพื่อดาวน์โหลด
  document.body.appendChild(link)
  link.click()

  // ลบลิงก์ออกจาก DOM และปล่อย URL
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
export default exportFile
